
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import AppAddNewMember from "./app-add-new-member.vue";
import AppSubscribeBtn from "./app-subscribe-btn.vue";
import appTile from "./app-tile.vue";
export default {
  components: { appTile, AppSubscribeBtn, AppAddNewMember },
  props: {
    appDetail: {}
  },
  data() {
    return {
      newMember: "",
      role: [],

      loading: false,
      selectRule: [(v) => !!v || "Please select a Role"]
    };
  },
  mounted() {
    this.handleFetchMembers();
  },
  computed: {
    appInfo() {
      return (
        this.linkedApps &&
        this.linkedApps().find((app) => app.source == this.appDetail.identifier)
      );
    }
  },
  methods: {
    ...mapActions("apps", ["fetchMembers", "addMember"]),
    ...mapState("restaurant", ["linkedApps"]),
    ...mapState("apps", ["members"]),
    handleDeleteMember() {
      console.log("Member Deleted");
    },
    handleAddMember() {
      this.loading = true;
      let formData = new FormData();
      formData.append("linked_apps[mobile_number]", "+91" + this.newMember);
      this.addMember({ appId: this.appInfo.id, formData })
        .then((response) => {
          if (response.data.status === "success") {
            this.$nuxt.$emit("show-toast", {
              text: response.data.messages || response.data.message,
              color: "success darken-2",
              icon: "done",
              flat: true
            });
            this.newMember = "";
            this.handleFetchMembers();
          } else {
            this.$nuxt.$emit("show-error-toast", response);
          }
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleFetchMembers() {
      if (this.appInfo) {
        this.fetchMembers(this.appInfo.id);
      }
    }
  }
};
